module.exports = __webpack_public_path__ + "img/pederneiras.dd266961.png";